import {
  BillLineInstallmentStatus,
  BillLineInstallmentV2,
  BillLineItemV2Kind,
} from '@types'
import { MockFactory } from '@tino-frontend/mocks'

export const lineItemInstallment = new MockFactory<BillLineInstallmentV2>({
  id: 'line_item_id_01',
  amount_cents: 10000,
  reference_date: '2023-12-01T00:00:00Z',
  payer_id: '8e1c9e14-80cf-4b3a-b4b3-f8047625e8b9',
  kind: BillLineItemV2Kind.Installment,
  metadata: {
    invoice_id: 'invoice_id_1',
    installment_id: 'installment-id-1',
    invoice_supplier_name: 'supplier N.',
    invoice_created_at: '2023-11-30T00:00:00Z',
    invoice_approved_at: '2023-12-01T00:00:00Z',
    tax_invoice_number: '0000 5502 4000 3657 0919 0000',
    tax_invoice_access_key: 'tax_invoice_access_key_1',
    versions: [
      {
        invoice_total_amount_cents: 60000,
        invoice_num_installments: 3,
        installment_edited_at: '',
        installment_number: 1,
        installment_total_amount_cents: 20000,
        installment_settlement_date: '2023-12-01T00:00:00Z',
        installment_estimated_due_date: '2023-12-01',
        installment_internal_status: BillLineInstallmentStatus.Open,
      },
    ],
    edition: {
      edited: false,
      reimbursed: false,
      canceled: false,
      lastEditionDate: '',
      newAmount: 0,
      originalAmount: 0,
    },
  },
})
